import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export interface SubjectData {
  id: string;
  name: string;
  subject?: { id: string };
}

export interface Subject {
  data: SubjectData[];
}

export const ClassSubjectsApi = createApi({
  reducerPath: 'ClassSubjectsApi',
  baseQuery,
  tagTypes: ['classSubjects'],
  endpoints: builder => ({
    getClassSubjects: builder.query<any, { classId: string | null }>({
      query: ({ classId }) => `/academics/classes/${classId}/subjects`,
      providesTags: ['classSubjects'],
    }),
    assignClassSubject: builder.mutation<
      any,
      { newSubject: any; classId: string }
    >({
      query: ({ newSubject, classId }) => ({
        url: `/academics/classes/${classId}/subjects`,
        method: 'POST',
        body: newSubject,
      }),
      invalidatesTags: ['classSubjects'],
    }),
    updateClassSubject: builder.mutation<
      any,
      { updateSubject: any; classId: string; id: string }
    >({
      query: ({ updateSubject, classId, id }) => ({
        url: `/academics/classes/${classId}/subjects/${id}`,
        method: 'PATCH',
        body: updateSubject,
      }),
      invalidatesTags: ['classSubjects'],
    }),
    deleteSubject: builder.mutation<
      void,
      { classId: string; subjectId: string }
    >({
      query: ({ classId, subjectId }) => ({
        url: `/academics/classes/${classId}/subjects/${subjectId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['classSubjects'],
    }),
    copyClassSubjects: builder.mutation<
      void,
      { classId: string; targetClassId: string }
    >({
      query: ({ classId, targetClassId }) => ({
        url: `/academics/classes/${classId}/subjects/copy-to/${targetClassId}`,
        method: 'POST',
      }),
      invalidatesTags: ['classSubjects'],
    }),
  }),
});

export const {
  useGetClassSubjectsQuery,
  useAssignClassSubjectMutation,
  useUpdateClassSubjectMutation,
  useDeleteSubjectMutation,
  useCopyClassSubjectsMutation,
} = ClassSubjectsApi;
